import {BreakpointObserver, Breakpoints} from '@angular/cdk/layout'
import {computed, inject, Service, signal} from '@angular/core'
import {ConfigService} from '@sparbanken-syd/sparbanken-syd-bankid'
import {IS_DOCUMENT_SUPER_USER_ROLE, IS_USER_ADMIN_ROLE} from '../application/data-types'

@Service()
export class Helper {
  public isSmallScreen = signal(false)

  private readonly breakpointObserver = inject(BreakpointObserver)

  constructor() {
    this.breakpointObserver.observe([
      Breakpoints.HandsetPortrait,
    ]).subscribe(r => this.isSmallScreen.set(r.matches))
  }

  public isUserAdmin = computed(() =>
    this.userRoles().includes(IS_USER_ADMIN_ROLE)
  )

  public isDocumentSuperUser = computed(() =>
    this.userRoles().includes(IS_DOCUMENT_SUPER_USER_ROLE)
  )

  private readonly service = inject(ConfigService)

  private readonly userRoles = computed(() => {
    return this.service.currentUser()?.roles ?? []
  })

}